<div class="h-full w-full flex flex-col flex-1 space-y-3">
	<div class="leading-none text-left font-semibold">
		{{ controller.baseI18n + '.title' | translate }}
	</div>
	<ng-container
		*ngFor="let certificate of certificatesArray.controls; let i = index"
	>
		<spr-coach-settings-general-certificates-header
			class="space-y-1"
		></spr-coach-settings-general-certificates-header>
		<spr-coach-settings-general-certificates-certificate
			[form]="certificate"
			class="flex flex-col items-stretch space-y-3"
		>
			<button
				[disabled]="!certificate.valid"
				(click)="onRemoveCertificateClick(i)"
				class="p-button-outlined border-none text-blue-900 text-lg"
				icon="fak fa-str-trash"
				pButton
			></button>
		</spr-coach-settings-general-certificates-certificate>
	</ng-container>
	<ng-container>
		<spr-coach-settings-general-certificates-header></spr-coach-settings-general-certificates-header>
		<spr-coach-settings-general-certificates-certificate
			[form]="newCertificate"
			class="flex flex-col items-stretch space-y-3"
		>
			<button
				[disabled]="!newCertificate.valid"
				(click)="onAddCertificateClick()"
				class="p-button-outlined border-none text-blue-900 text-lg leading-none"
				icon="fas fa-plus"
				pButton
			></button>
		</spr-coach-settings-general-certificates-certificate>
	</ng-container>
</div>
